import React, { useEffect } from 'react';
import * as mobxReact from 'mobx-react';
import { SubWindowsHost } from '../../global/sub-window/sub-windows-host';
import { AttributesTab, ManageAttributesVM } from './manage-attributes.viewmodel';
import { EventLevelAttributes } from './event-attributes/event-level-attributes';

export type ManageAttributesPresentationProps = {
    vm: ManageAttributesVM;
};

export const ManageAttributesTabContent = (props: { activeTab: AttributesTab }): JSX.Element => {
    switch (props.activeTab) {
        case AttributesTab.EventLevelAttributes:
            return <EventLevelAttributes/>;
        default:
            return null;
    }
};

export const ManageAttributesPresentation = mobxReact.observer(({ vm }: ManageAttributesPresentationProps): JSX.Element => {
    useEffect(() => {
        return () => vm.willUnmount();
    }, []);

    return (
         <SubWindowsHost>
            <div className='page-container'>
                <ManageAttributesTabContent activeTab={vm.getActiveTab()} />
            </div>
         </SubWindowsHost>
    );
});
